import { h } from 'preact'
import { t } from '../beacon-i18n.js'

function formatDateTime(iso) {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })
}

/**
 * EmailThreadScreen — full text of a selected email thread (root email +
 * replies), from GET /support/widget/conversations/:id (email type only).
 * Read-only view — no reply composer in the widget (email-only conversations
 * continue via the normal Support Inbox, see plan).
 *
 * Response shape (Support::WidgetController#show):
 * { id, subject, status, created_at, updated_at,
 *   messages: [{ id, direction, from_name, from_address, body_html, body_text, sent_at, created_at }] }
 */
export function EmailThreadScreen({ store }) {
  const thread = store.activeEmailThread.value

  if (!thread) {
    return <div class="beacon-thread-loading">{t('support.beacon.email_thread.loading')}</div>
  }

  const messages = thread.messages || []

  return (
    <div class="beacon-email-thread-screen">
      <h3 class="beacon-thread-subject">{thread.subject}</h3>

      <div class="beacon-thread-messages">
        {messages.map((message, index) => (
          <div key={message.id || index} class={`beacon-thread-message beacon-thread-message-${message.direction || 'inbound'}`}>
            <div class="beacon-thread-message-header">
              <span class="beacon-thread-message-sender">{message.from_name || message.from_address}</span>
              <span class="beacon-thread-message-time">{formatDateTime(message.sent_at || message.created_at)}</span>
            </div>
            <div class="beacon-thread-message-body">
              {message.body_text}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
